import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getMeAsync } from "../store/features/auth/loginAPI";
import { useAppDispatch, useAppSelector } from "../store/store";

export default function useAppBoot() {
  const { loading } = useAppSelector((state) => state.login);
  const dispatch = useAppDispatch();
  const { keycloak, initialized } = useKeycloak();
  const [search] = useSearchParams();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (initialized && keycloak?.token) {
      dispatch(
        getMeAsync({
          token: keycloak?.token,
        })
      );
    }
  }, [dispatch, initialized, keycloak?.token]);

  useEffect(() => {
    const type = search.get("type");
    const dynamicId = search.get("dynamic-id");
    const dynamicKeyword = search.get("dynamic-keyword");

    if (type) {
      localStorage.setItem("product-type", JSON.stringify(type));
    }

    if (dynamicId && dynamicKeyword) {
      localStorage.setItem(
        "dynamic",
        JSON.stringify({
          dynamicId,
          dynamicKeyword,
        })
      );
    }
  }, [search]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 1000);
  // }, []);

  const isAppLoading = !initialized || loading || isLoading;

  // const navigateUrl =
  //   role === "admin" ? "/admin/dashboard" : "/organization/dashboard";
  // navigateUrl

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  return { loading: isAppLoading };
}
